// import bd_flag from "../../../assets/icons/bd_flag.ico";
import { useState } from "react";
import convertBDTimeToLocal from "./../../utils/convertBDTimeToLocal";
import digitConverter from "./../../utils/digitConverter";
export default function ArabicSchedule({ course, title }) {
  const [activeTab, setActiveTab] = useState("level1");

  const courseSchedules = {
    academic_ar: {
      level1: [
        { activity: "ক্লাস", day: "Saturday", time: "7:00" },
        { activity: "ক্লাস", day: "Monday", time: "7:00" },
        { activity: "ক্লাস", day: "Wednesday", time: "7:00" },
        { activity: "সাপ্তাহিক পরীক্ষা", day: "Friday", time: "16:00" },
      ],
      level2: [
        { activity: "ক্লাস", day: "Sunday", time: "7:00" },
        { activity: "ক্লাস", day: "Tuesday", time: "7:00" },
        { activity: "ক্লাস", day: "Thursday", time: "7:00" },
        { activity: "সাপ্তাহিক পরীক্ষা", day: "Friday", time: "16:00" },
      ],
      level3: [],
      level4: [],
    },
    madina_ar: {
      level1: [
        { activity: "ক্লাস", day: "Saturday", time: "19:30" },
        { activity: "ক্লাস", day: "Monday", time: "19:30" },
        { activity: "ক্লাস", day: "Wednesday", time: "19:30" },
        { activity: "সাপ্তাহিক পরীক্ষা", day: "Friday", time: "16:00" },
      ],
      level2: [
        { activity: "ক্লাস", day: "Sunday", time: "21:00" },
        { activity: "ক্লাস", day: "Tuesday", time: "21:00" },
        { activity: "ক্লাস", day: "Thursday", time: "21:00" },
        { activity: "সাপ্তাহিক পরীক্ষা", day: "Friday", time: "16:00" },
      ],
      level3: [],
    },
    grammar_ar: {
      level1: [
        { activity: "ক্লাস", day: "Saturday", time: "15:30" },
        { activity: "ক্লাস", day: "Monday", time: "15:30" },
        { activity: "ক্লাস", day: "Wednesday", time: "15:30" },
        { activity: "সাপ্তাহিক পরীক্ষা", day: "Friday", time: "15:00" },
      ],
      level2: [
        { activity: "ক্লাস", day: "Sunday", time: "15:30" },
        { activity: "ক্লাস", day: "Tuesday", time: "15:30" },
        { activity: "ক্লাস", day: "Thursday", time: "15:30" },
        { activity: "সাপ্তাহিক পরীক্ষা", day: "Friday", time: "15:00" },
      ],
      level3: [],
      level4: [],
    },
  };

  return (
    <section className="my-10">
      <div className="flex items-center">
        <span className="text-xl">ক্লাসের সময়ঃ </span>
        {/* <div className="ml-3">
          <img className="" src={bd_flag} alt="" />
        </div> */}
        <span className="ml-3">
          আপনার স্থানীয় সময় ({Intl.DateTimeFormat().resolvedOptions().timeZone})
          অনুযায়ী
        </span>
      </div>

      <div role="tablist" className="tabs tabs-bordered md:mx-20 md:mt-16">
        {Object.keys(courseSchedules?.[course] || {}).length > 0 &&
          Object.keys(courseSchedules[course]).map((level, i) => (
            <button
              key={level}
              role="tab"
              className={`tab ${activeTab === level ? "tab-active" : ""}`}
              onClick={() => setActiveTab(level)}
            >
              লেভেল {digitConverter(level.replace("level", ""))}
            </button>
          ))}
      </div>

      {activeTab === "level0" && (
        <div className="my-10 py-10 bg-sky-200 rounded schedule_card">
          <div className="text-xl text-center my-10">
            <p className="">{title} - লেভেল ০</p>
          </div>
          <div className="overflow-x-auto ">
            <table className="table  w-3/4 mx-auto text-xl ">
              <thead>
                <tr>
                  <th></th>
                  <th className="text-xl">
                    সময়
                    <span className="text-sm ml-3">
                      {Intl.DateTimeFormat()
                        .resolvedOptions()
                        .timeZone.split("/")[1]
                        .toUpperCase()}
                    </span>
                  </th>
                  <th className="text-xl">কার্যক্রম</th>
                </tr>
              </thead>
              <tbody>
                {courseSchedules?.[course]?.level0.map((schedule, index) => (
                  <tr key={schedule.day}>
                    <td>{index + 1}</td>
                    <td>{convertBDTimeToLocal(schedule.day, schedule.time)}</td>

                    <td>{schedule.activity}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {activeTab === "level1" && (
        <div className="my-10 py-10 bg-green-200 rounded schedule_card">
          <div className="text-xl text-center my-10">
            <p className="">{title} - লেভেল ১</p>
          </div>
          <div className="overflow-x-auto ">
            <table className="table  w-3/4 mx-auto text-xl ">
              <thead>
                <tr>
                  <th></th>
                  <th className="text-xl">
                    সময়
                    <span className="text-sm ml-3">
                      {Intl.DateTimeFormat()
                        .resolvedOptions()
                        .timeZone.split("/")[1]
                        .toUpperCase()}
                    </span>
                  </th>
                  <th className="text-xl">কার্যক্রম</th>
                </tr>
              </thead>
              <tbody>
                {courseSchedules?.[course]?.level1.map((schedule, index) => (
                  <tr key={schedule.day}>
                    <td>{index + 1}</td>
                    <td>{convertBDTimeToLocal(schedule.day, schedule.time)}</td>
                    <td>{schedule.activity}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {activeTab === "level2" && (
        <div className="my-10 py-10 bg-violet-200 rounded schedule_card">
          <div className="text-xl text-center my-10">
            <p className="">{title} - লেভেল ২</p>
          </div>
          <div className="overflow-x-auto ">
            <table className="table  w-3/4 mx-auto text-xl ">
              <thead>
                <tr>
                  <th></th>
                  <th className="text-xl">
                    সময়
                    <span className="text-sm ml-3">
                      {Intl.DateTimeFormat()
                        .resolvedOptions()
                        .timeZone.split("/")[1]
                        .toUpperCase()}
                    </span>
                  </th>
                  <th className="text-xl">কার্যক্রম</th>
                </tr>
              </thead>
              <tbody>
                {courseSchedules?.[course]?.level2.map((schedule, index) => (
                  <tr key={schedule.day}>
                    <td>{index + 1}</td>
                    <td>{convertBDTimeToLocal(schedule.day, schedule.time)}</td>
                    <td>{schedule.activity}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {activeTab === "level3" && (
        <div className="my-10 py-10 bg-rose-200 rounded schedule_card">
          <div className="text-xl text-center my-10">
            <p className="">{title} - লেভেল ৩</p>
          </div>
          <div className="overflow-x-auto ">
            <table className="table  w-3/4 mx-auto text-xl ">
              <thead>
                <tr>
                  <th></th>
                  <th className="text-xl">
                    সময়
                    <span className="text-sm ml-3">
                      {Intl.DateTimeFormat()
                        .resolvedOptions()
                        .timeZone.split("/")[1]
                        .toUpperCase()}
                    </span>
                  </th>
                  <th className="text-xl">কার্যক্রম</th>
                </tr>
              </thead>
              <tbody>
                {courseSchedules?.[course]?.level3.map((schedule, index) => (
                  <tr key={schedule.day}>
                    <td>{index + 1}</td>
                    <td>{convertBDTimeToLocal(schedule.day, schedule.time)}</td>
                    <td>{schedule.activity}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {activeTab === "level4" && (
        <div className="my-10 py-10 bg-cyan-200 rounded schedule_card">
          <div className="text-xl text-center my-10">
            <p className="">{title} - লেভেল ৪</p>
          </div>
          <div className="overflow-x-auto ">
            <table className="table  w-3/4 mx-auto text-xl ">
              <thead>
                <tr>
                  <th></th>
                  <th className="text-xl">
                    সময়
                    <span className="text-sm ml-3">
                      {Intl.DateTimeFormat()
                        .resolvedOptions()
                        .timeZone.split("/")[1]
                        .toUpperCase()}
                    </span>
                  </th>
                  <th className="text-xl">কার্যক্রম</th>
                </tr>
              </thead>
              <tbody>
                {courseSchedules?.[course]?.level4.map((schedule, index) => (
                  <tr key={schedule.day}>
                    <td>{index + 1}</td>
                    <td>{convertBDTimeToLocal(schedule.day, schedule.time)}</td>
                    <td>{schedule.activity}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </section>
  );
}
